export default "__VITE_ASSET__131c69ec__"